export interface IMicromobilityFilters {
  showStopAreas: boolean;
  showBikeStations: boolean;
  showElectricBikes: boolean | undefined;
  showElectricBikesVoi: boolean;
  showElectricBikesDott: boolean;
  showScooters: boolean | undefined;
  showScootersRyde: boolean;
  showScootersVoi: boolean;
  showScootersDott: boolean;
}

export const initialMicromobilityFilters: IMicromobilityFilters = {
  showStopAreas: true,
  showBikeStations: true,
  showElectricBikes: true,
  showElectricBikesVoi: true,
  showElectricBikesDott: true,
  showScooters: true,
  showScootersRyde: true,
  showScootersVoi: true,
  showScootersDott: true,
};

export const isValidMicromobilityFilters = (obj: unknown) => {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  const obj2 = obj as IMicromobilityFilters;
  if (obj2.showStopAreas !== undefined && typeof obj2.showStopAreas !== 'boolean') {
    return false;
  }
  if (obj2.showBikeStations !== undefined && typeof obj2.showBikeStations !== 'boolean') {
    return false;
  }
  if (obj2.showElectricBikesVoi !== undefined && typeof obj2.showElectricBikesVoi !== 'boolean') {
    return false;
  }
  if (obj2.showElectricBikesDott !== undefined && typeof obj2.showElectricBikesDott !== 'boolean') {
    return false;
  }
  if (obj2.showScooters !== undefined && typeof obj2.showScooters !== 'boolean') {
    return false;
  }
  if (obj2.showScootersRyde !== undefined && typeof obj2.showScootersRyde !== 'boolean') {
    return false;
  }
  if (obj2.showScootersVoi !== undefined && typeof obj2.showScootersVoi !== 'boolean') {
    return false;
  }
  if (obj2.showScootersDott !== undefined && typeof obj2.showScootersDott !== 'boolean') {
    return false;
  }

  return true;
};
